import cn from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from 'components/shared/table';
import LinkButton from 'components/shared/LinkButton';
import RSVPStatus from './RSVPStatus';
import AttendanceStatus from './AttendanceStatus';

class AttendanceRowMultipleColumn extends Component {
  render() {
    const {
      attendance,
      contentItems,
      currentSessionId,
      displayAsSearchResult = false,
      event,
      isMultiSession,
      rsvpType,
      searchResultsFlag,
      sessions,
      showAttendanceDropdown,
      updateAttendance,
    } = this.props;
    const currentSession = sessions.find(
      session => Number(session.id) === Number(currentSessionId),
    );
    const attendanceTaken = currentSession
      ? currentSession.attendance_taken
      : event.last_session && event.last_session.attendance_taken;
    const useExpandedColumns = displayAsSearchResult && !attendanceTaken;
    const hasAssignedContentAndFlag =
      !!contentItems.length && contentItems.every(item => item.assigned_at);

    const getRelevantSessionRsvp = () => {
      if (currentSessionId) {
        const currentRsvp = attendance.sessions.find(
          session => Number(session.id) === Number(currentSessionId),
        );
        return currentRsvp;
      }
      if (!isMultiSession || rsvpType === 'all') {
        return attendance.sessions[0];
      }
      let relevantStatus;
      const positiveStatus = attendance.sessions.find(session =>
        ['will_attend', 'did_attend'].includes(session.rsvpStatus),
      );
      if (positiveStatus) {
        relevantStatus = positiveStatus;
      } else {
        const negativeStatus = attendance.sessions.find(session =>
          ['will_not_attend', 'did_not_attend'].includes(session.rsvpStatus),
        );
        relevantStatus = { ...negativeStatus, id: null, name: null };
      }
      return relevantStatus || attendance.sessions[0];
    };

    const relevantSessionRsvp = getRelevantSessionRsvp();
    const attendeeWithRelevantSessionRsvp = {
      ...attendance,
      sessions: [relevantSessionRsvp],
    };

    const getRelevantSessionAttendance = () => {
      if (!isMultiSession || currentSessionId || rsvpType === 'single') {
        return relevantSessionRsvp;
      }
      if (
        attendance.sessions.every(
          session => session.attendanceStatus === 'attended',
        ) ||
        attendance.sessions.every(
          session => session.attendanceStatus === 'did_not_attend',
        )
      ) {
        return relevantSessionRsvp;
      }
      relevantSessionRsvp.attendanceStatus = 'unconfirmed';
      return relevantSessionRsvp;
    };
    const relevantSessionAttendance = getRelevantSessionAttendance();

    if (relevantSessionAttendance === undefined) {
      return null;
    }

    const attendeeWithRelevantSessionAttendance = {
      ...attendance,
      sessions: [relevantSessionAttendance],
    };

    return (
      <Table.Row
        className={
          searchResultsFlag ? 'AttendanceRow' : 'AttendanceRow pl-8 pr-8'
        }
      >
        {!isMultiSession && (
          <Table.Body.Cell contentClassName="d-f fd-r">
            <div className="UserColumnCell">
              {attendance.name || attendance.user?.name}
            </div>
            <div
              className={cn('d-f jc-sb fd-r', {
                'fg-1': !useExpandedColumns,
              })}
            >
              <div className="d-f jc-sb fd-r minw-120">
                {relevantSessionRsvp && (
                  <RSVPStatus
                    attendee={attendeeWithRelevantSessionRsvp}
                    event={event}
                    showAttendanceDropdown={showAttendanceDropdown}
                    updateAttendance={updateAttendance}
                    sessions={sessions}
                    isMultiSession={isMultiSession}
                    rsvpType={rsvpType}
                  />
                )}
              </div>
              {!useExpandedColumns && (
                <div className="d-f jc-sb fd-r minw-150">
                  {(attendanceTaken ||
                    currentSession?.video_meeting?.attendance_taken ||
                    attendance.created_from === 'created_manually') &&
                    relevantSessionAttendance && (
                      <AttendanceStatus
                        sessions={sessions}
                        isMultiSession={isMultiSession}
                        attendee={attendeeWithRelevantSessionAttendance}
                        event={event}
                        showAttendanceDropdown={showAttendanceDropdown}
                        updateAttendance={updateAttendance}
                        hasAssignedContentAndFlag={hasAssignedContentAndFlag}
                      />
                    )}
                </div>
              )}
            </div>
          </Table.Body.Cell>
        )}
        {isMultiSession && (
          <div
            className={cn(
              `d-f jc-sb fd-r ${isMultiSession ? 'AttendanceCell' : ''}`,
              {
                'fg-1': !useExpandedColumns,
              },
            )}
          >
            <Table.Body.Cell>
              <div>{attendance.name || attendance.user?.name}</div>
            </Table.Body.Cell>
            <Table.Body.Cell>
              <div className="d-f jc-sb fd-r minw-120">
                {relevantSessionRsvp && (
                  <RSVPStatus
                    sessions={sessions}
                    isMultiSession={isMultiSession}
                    attendee={attendeeWithRelevantSessionRsvp}
                    event={event}
                    showAttendanceDropdown={showAttendanceDropdown}
                    updateAttendance={updateAttendance}
                    currentSessionId={currentSessionId}
                    rsvpType={rsvpType}
                  />
                )}
              </div>
            </Table.Body.Cell>
            {!currentSessionId && rsvpType === 'single' && (
              <Table.Body.Cell>
                <div>
                  {!relevantSessionRsvp?.rsvpStatus && <div>-</div>}
                  {relevantSessionRsvp?.rsvpStatus && (
                    <LinkButton
                      type=""
                      className="u-linkBtn"
                      onClick={() => {
                        window.location = `/in_person_training/events/${event.id}/sessions/${relevantSessionRsvp.id}`;
                      }}
                    >
                      {relevantSessionRsvp.name}
                    </LinkButton>
                  )}
                </div>
              </Table.Body.Cell>
            )}
            {(currentSessionId || !isMultiSession) && (
              <Table.Body.Cell>
                {!useExpandedColumns && (
                  <div className="d-f jc-sb fd-r minw-150">
                    {(attendanceTaken ||
                      currentSession?.video_meeting?.attendance_taken ||
                      attendance.created_from === 'created_manually') &&
                      relevantSessionAttendance && (
                        <AttendanceStatus
                          sessions={sessions}
                          isMultiSession={isMultiSession}
                          attendee={attendeeWithRelevantSessionAttendance}
                          event={event}
                          showAttendanceDropdown={showAttendanceDropdown}
                          updateAttendance={updateAttendance}
                          hasAssignedContentAndFlag={hasAssignedContentAndFlag}
                        />
                      )}
                  </div>
                )}
              </Table.Body.Cell>
            )}
          </div>
        )}
      </Table.Row>
    );
  }
}

const mapStateToProps = state => ({
  contentItems: state.associatedContent.contentItems,
  event: state.event,
  showAttendanceDropdown: !state.event.is_archived,
});

export default connect(mapStateToProps)(AttendanceRowMultipleColumn);
